<div class="d-flex flex-column gap-4" [formGroup]="formGroup">
  <ng-container
    formArrayName="roles"
    *ngFor="let control of rolesFormArray.controls; let i = index; let last = last; let first = first">
    <div class="role-row">
      <label class="form-input-label" [for]="'roles.' + i" i18n>Role</label>
      <div [ngClass]="{ 'grid-layout': gridLayout, 'col-layout': !gridLayout }">
        <div class="role-dropdown">
          <app-dropdown-input
            [formControlName]="i"
            [error]="submitAttempted && control.invalid"
            [controlId]="'roles.' + i"
            [disabled]="!(canEditUserDetails$ | async)"
            placeholder="Choose a Role"
            i18n-placeholder
            [dropdowns]="(roleDropdownOptions$ | async) ?? undefined" />
          <app-form-error *ngIf="submitAttempted && control.invalid" [errors]="control.errors" />
        </div>
        <div class="remove-role-button" [class.m-auto]="gridLayout">
          <button
            type="button"
            [disabled]="!(canEditUserDetails$ | async) || (first && last)"
            [ngClass]="{
              'disable-button': !(canEditUserDetails$ | async) || (first && last)
            }"
            (click)="removeRole(i)"
            class="destructive-paddingless-text-button">
            <ng-container i18n>Remove Role</ng-container>
          </button>
        </div>
      </div>
      <hr [style.margin-top.rem]="!first ? 1 : 1.5" *ngIf="!gridLayout" />
    </div>
    <div *ngIf="last && !(hideAddRoleButton$ | async)" class="additional-button">
      <button
        type="button"
        class="add-another no-style-button"
        [style.margin.rem]="0"
        [disabled]="!(canEditUserDetails$ | async)"
        (click)="addAdditionalRole(i)"
        i18n>
        Add Additional Role
      </button>
    </div>
  </ng-container>
</div>
